import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';
import { Vendor } from '../../../core/models/entities/vendor';
import { selectUiState } from '../../../core/store/reducers';

@Component({
  selector: 'app-vendor-privacy-policy-page',
  template: `
    <div class="container py-6">
      @if (vendor$ | async; as vendor) {
        <div class="mt-10">
          <div class="text-4xl font-bold">Politique de confidentialité</div>
          <div class="font-sembibold mt-4 text-xl uppercase">{{
            vendor.name
          }}</div>
          <p class="mt-10">
            Votre interlocuteur (<span class="font-bold">{{ vendor.name }}</span
            >) s'engage à suivre et respecter la politique de confidentialité de
            la plateforme location-salles.ch, développée par
            <a href="https://www.ercos.ch" target="_blank">Ercos SA</a>.</p
            >
            <div class="mt-8">
              <a routerLink="/politique-confidentialite" target="_blank">
                <app-button variant="primary"
                  >Politique de confidentialité</app-button
                  >
                </a>
              </div>
            </div>
          } @else {
            <app-loader [centered]="true"></app-loader>
          }
    
        </div>
    `,
  styles: [],
  standalone: false,
})
export class VendorPrivacyPolicyPageComponent implements OnInit {
  vendor$: Observable<Vendor> = this.store
    .select(selectUiState)
    .pipe(map((uiState) => uiState.vendor));

  constructor(private store: Store) {}

  ngOnInit(): void {}
}
